import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { setPerfRoute } from './perfContext';

export function PerfRouteObserver() {
  const { pathname } = useLocation();
  useLayoutEffect(() => { setPerfRoute(pathname); }, [pathname]);
  return null;
}
